import { useEffect, useState } from "react";
import { Info, Search } from "react-feather";
import { useSelector } from "react-redux";
import {
  filterChargeTypes,
  getChargeTypeDetails,
} from "../../api/finance/chargeTypeApi";
import { getBulkDropdownData } from "../../api/keyvalue";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Button from "../../components/input/Button";
import useUserCompany from "../../hooks/useUserCompany";
import Dropdown from "../input/Dropdown";
import Input from "../input/Input";
import SideDrawer from "../input/SideDrawer";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../renderer/StyleRenderer";
import ChargeTypeAdd from "./ChargeTypeAdd";

function ChargeType() {
  const userCompany = useUserCompany();
  const user = useSelector((state) => state.user);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [activeAccordion, setActiveAccordion] = useState(1);
  const [tab, setTab] = useState(1);
  const [editMode, setEditMode] = useState(false);
  const [isDropdownLoading, setIsDropdownLoading] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [chName, setChName] = useState("");
  const [chCode, setChCode] = useState("");
  const [chEv, setChEv] = useState("");
  const [chInv, setChInv] = useState("");
  const [chStatus, setChStatus] = useState("");
  const [chNegotiation, setChNegotiation] = useState("");
  const [fromdate, setFromdate] = useState("");
  const [todate, setTodate] = useState("");
  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null
  );
  const [statusTypeOptions, setStatusTypeOptions] = useState([]);
  const [yesnoOptions, setYesnoOptions] = useState([]);
  const [negotiationOptions, setNegotiationOptions] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [currentValues, setCurrentValues] = useState({});

  useEffect(() => {
    (async () => {
      setIsDropdownLoading(true);
      const {
        status: statusTypeData,
        yesno: yesNoData,
        negotiation_charge: negotiationType,
      } = await getBulkDropdownData([
        { key: "status" },
        { key: "yesno" },
        { key: "negotiation_charge" },
      ]);
      setStatusTypeOptions(statusTypeData);
      setYesnoOptions(yesNoData);
      setNegotiationOptions(negotiationType);
      setIsDropdownLoading(false);
    })();
  }, []);

  useEffect(() => {
    const aWeekAgo = new Date();
    aWeekAgo.setDate(aWeekAgo.getDate() - 7);
    const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
    setFromdate(formattedWeekAgo);
    const formattedToday = new Date().toISOString().split("T")[0];
    setTodate(formattedToday);
  }, []);

  useEffect(() => {
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);

  const handleAccordionClick = (index) => {
    setActiveAccordion(index === activeAccordion ? null : index);
  };
  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };
  const handleSearch = async () => {
    setActiveAccordion(false);
    setSearchClicked(true);
    setIsLoading(true);

    const response = await filterChargeTypes({
      chName,
      chCode,
      chEv,
      chInv,
      chStatus,
      chNegotiation,
      // fromdate,
      // todate,
      company,
      user: user.username,
    });
    setSearchData(response);
    setIsLoading(false);
    // setSearchClicked(false);
  };

  const handleReset = () => {
    setChName("");
    setChCode("");
    setChEv("");
    setChInv("");
    setChStatus("");
    setChNegotiation("");
    const aWeekAgo = new Date();
    aWeekAgo.setDate(aWeekAgo.getDate() - 7);
    const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
    setFromdate(formattedWeekAgo);
    const formattedToday = new Date().toISOString().split("T")[0];
    setTodate(formattedToday);
    setSearchClicked(false);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    setEditMode(false);
  };

  return (
    <>
      <div
        className="ui attached tabular"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="ui top attached  menu tabular">
          <div
            className={`item ${tab === 1 ? "active" : ""}`}
            onClick={() => {
              setTab(1);
            }}
          >
            <span>
              <Info size={15} style={{ marginRight: "5px" }} />
            </span>
            Charge Type
          </div>
        </div>
        <Button
          template="drawerOpen"
          onClick={handleDrawerOpen}
          editMode={false}
        />
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion === 1 ? "active" : ""}`}
            onClick={() => handleAccordionClick(1)}
          >
            <div>
              Search
              <Search size={14} style={{ marginLeft: "10px" }} />
              <i className="dropdown icon"></i>
            </div>
          </div>
          <div className={`content ${activeAccordion === 1 ? "active" : ""}`}>
            {isDropdownLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <div className="two fields">
                  <Input
                    type={"text"}
                    label={"Charge type Name"}
                    placeholder="Charge Type Name"
                    value={chName}
                    onChange={(e) => setChName(e.target.value)}
                  />
                  <Input
                    type="text"
                    label={"Charge code"}
                    placeholder="Charge Code"
                    value={chCode}
                    onChange={(e) => setChCode(e.target.value)}
                  />
                </div>

                <div className="three fields">
                  <Dropdown
                    label={"EV"}
                    options={yesnoOptions}
                    placeholder="EV"
                    value={chEv}
                    onChange={(e, data) => setChEv(data.value)}
                  />
                  <Dropdown
                    label={"INV"}
                    options={yesnoOptions}
                    placeholder="INV"
                    value={chInv}
                    onChange={(e, data) => setChInv(data.value)}
                  />
                  <Dropdown
                    label={"Status"}
                    options={statusTypeOptions}
                    placeholder="Status"
                    value={chStatus}
                    onChange={(e, data) => setChStatus(data.value)}
                  />
                  <Dropdown
                    label={"Negotiation Type"}
                    options={negotiationOptions}
                    placeholder="Negotiation Type"
                    value={chNegotiation}
                    onChange={(e, data) => setChNegotiation(data.value)}
                  />
                  {/* <Input
                        label={"From date"}
                        type="date"
                        value={fromdate}
                        onChange={(e) => setFromdate(e.target.value)}
                      />
                      <Input
                        label={"To date"}
                        type="date"
                        value={todate}
                        onChange={(e) => setTodate(e.target.value)}
                      /> */}
                </div>

                <div style={{ textAlign: "right" }}>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div className="field" style={{ width: "100%" }}>
                      <Button template="search" onClick={handleSearch} />
                      <Button template="searchReset" onClick={handleReset} />
                    </div>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        searchClicked && (
          <Grid
            content={searchData}
            config={[
              { headerName: "Charge Code", field: "chtCode" },
              {
                headerName: "Charge Type",
                field: "chtCharge",
                cellRenderer: ResizableScrollingTextRenderer,
              },
              {
                headerName: "Charge Description",
                field: "chtDescription",
                cellRenderer: ResizableScrollingTextRenderer,
              },
              {
                headerName: "Percentage",
                field: "chtPercentage",
                width: "150",
                minWidth: "150",
              },
              {
                headerName: "EV",
                field: "chtEv",
                width: "150",
                minWidth: "150",
              },
              {
                headerName: "INV",
                field: "chtInvoice",
                width: "150",
                minWidth: "150",
              },
              {
                headerName: "Primary",
                field: "chtPrimary",
                width: "150",
                minWidth: "150",
              },
              {
                headerName: "Tax Values",
                field: "chtTaxValues",
                width: "180",
                minWidth: "180",
                cellRenderer: ResizableScrollingTextRenderer,
              },
              {
                headerName: "Negotiation Type",
                field: "chtNegotiationValue",
                width: "150",
                minWidth: "150",
                cellRenderer: ResizableScrollingTextRenderer,
              },
              {
                headerName: "Status",
                field: "chtStatusValue",
                cellRenderer: StatusCellStyle,
              },
              {
                headerName: "Active",
                field: "chtActiveValue",
                cellRenderer: ActiveCellStyle,
              },
            ]}
            onCellDoubleClicked={async (props) => {
              console.log("props: ", props.data);
              const response = await getChargeTypeDetails(props.data.chtId);
              setCurrentValues(response);
              setDrawerOpen(true);
              setEditMode(true);
            }}
          />
        )
      )}

      {/* Side Drawer */}
      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          editMode ? (
            <div className="drawer-header">
              <div
                style={{ padding: "10px 16px", borderBottom: "1px solid #ccc" }}
              >
                <h3>
                  {!editMode
                    ? "Add Charge Type"
                    : `Charge Code: ${currentValues?.chtCode} `}
                </h3>
              </div>
            </div>
          ) : null
        }
        body={
          <ChargeTypeAdd
            editMode={editMode}
            handleDrawerClose={handleDrawerClose}
            currentValues={currentValues}
          />
        }
        style={{ width: "60vw", boxShadow: "none" }}
      />
    </>
  );
}
export default ChargeType;
